import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import ReactTable from 'react-table'
import * as Yup from 'yup'
import {
  DarkBlue,
  DarkBlueHover,
  DarkRedHover,
  Red,
} from '../../../../assets/colors'
import Button from '../../../../components/Button'
import FormField from '../../../../components/Form/FormField'
import Modal from '../../../../components/Modal'
import * as S from '../../../../components/ModalRemoveBatch/styles'

const ModalDeleteFract = ({ deleteObject, deleteAction, cancelAction }) => {
  const title = 'Deseja remover essa fração ?'

  const closeModal = () => {
    cancelAction()
  }

  const [errorMessage, setErrorMessage] = useState('')

  return (
    <Modal
      show={deleteObject !== undefined}
      closedButton={false}
      title={title}
      body={(
        <Formik
          initialValues={{
            badgeUser: undefined,
          }}
          validationSchema={Yup.object().shape({
            badgeUser: Yup.string().required('form.required'),
          })}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            deleteAction(values.badgeUser)
              .then(() => {
                closeModal()
              })
              .catch((error) => {
                if (error?.response) {
                  const { message } = error?.response.data
                  if (error?.response.status === 401) {
                    setErrors({
                      badgeUser: message,
                    })
                  } else {
                    setErrorMessage(message)
                  }
                } else {
                  setErrorMessage(
                    'Não foi possivel remover a fração desse lote',
                  )
                }
              })
              .finally(() => {
                setSubmitting(false)
              })
          }}
        >
          {({ isSubmitting, handleSubmit }) => (
            <Form style={{ padding: '0 20px 20px 20px' }}>
              <S.ModalBody>
                <h5>Fração selecionada</h5>

                <FormField
                  label='badge.inspector'
                  name='badgeUser'
                  fieldType='password'
                  styleContainer={{ margin: '0 0 10px 0' }}
                />

                <ReactTable
                  className='-striped -highlight'
                  data={deleteObject ? [deleteObject] : []}
                  resolveData={(data) => {
                    if (data) {
                      return data.map((row) => row)
                    }
                    return []
                  }}
                  resizable={false}
                  showPagination={false}
                  showPageSizeOptions={false}
                  loading={false}
                  columns={[
                    {
                      Header: 'Fração',
                      id: 'qtyElement',
                      accessor: 'qtyElement',
                      getProps: () => ({
                        style: {
                          textAlign: 'center',
                        },
                      }),
                    },
                  ]}
                  defaultPageSize={1}
                />
                {errorMessage && (
                  <p
                    style={{
                      color: 'red',
                      fontWeight: 'bold',
                      fontSize: '16x',
                    }}
                  >
                    {' '}
                    {errorMessage}{' '}
                  </p>
                )}
              </S.ModalBody>
              <S.ModalFooter>
                <Button
                  text='Excluir'
                  className='submit-button'
                  style={{
                    marginRight: '5px',
                    height: '45px',
                    width: '150px',
                    padding: 0,
                    margin: 0,
                  }}
                  onClick={() => {
                    setErrorMessage('')
                    handleSubmit()
                  }}
                  color={Red}
                  hoverColor={DarkRedHover}
                  isDisabled={isSubmitting}
                />

                <Button
                  text='Cancelar'
                  onClick={closeModal}
                  style={{
                    marginRight: '5px',
                    height: '45px',
                    width: '150px',
                    padding: 0,
                    margin: 0,
                  }}
                  color={DarkBlue}
                  hoverColor={DarkBlueHover}
                  isDisabled={isSubmitting}
                />
              </S.ModalFooter>
            </Form>
          )}
        </Formik>
      )}
    />
  )
}

export default ModalDeleteFract
